const BookIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_91)">
        <path
          d="M38 4H36V2C36 0.896 35.104 0 34 0C32.896 0 32 0.896 32 2V4H16V2C16 0.896 15.104 0 14 0C12.896 0 12 0.896 12 2V4H10C4.486 4 0 8.486 0 14V38C0 43.514 4.486 48 10 48H38C43.514 48 48 43.514 48 38V14C48 8.486 43.514 4 38 4ZM10 8H38C41.308 8 44 10.692 44 14V16H4V14C4 10.692 6.692 8 10 8ZM38 44H10C6.692 44 4 41.308 4 38V20H44V38C44 41.308 41.308 44 38 44ZM32 32C32 33.104 31.104 34 30 34H26V38C26 39.104 25.104 40 24 40C22.896 40 22 39.104 22 38V34H18C16.896 34 16 33.104 16 32C16 30.896 16.896 30 18 30H22V26C22 24.896 22.896 24 24 24C25.104 24 26 24.896 26 26V30H30C31.104 30 32 30.896 32 32Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_91">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const ProfileIcon = () => {
  return (
    <svg
      width="67"
      height="67"
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.4907 63.3708C33.2177 63.3708 32.9649 63.3243 32.7323 63.2313C32.4997 63.1382 32.267 62.9753 32.0344 62.7427L25.0552 55.7635H12.5625C11.4458 55.7635 10.4688 55.3448 9.63125 54.5073C8.79375 53.6698 8.375 52.6927 8.375 51.576V9.70104C8.375 8.54948 8.79375 7.56367 9.63125 6.74362C10.4688 5.92357 11.4458 5.51354 12.5625 5.51354H54.4375C55.5542 5.51354 56.5313 5.92357 57.3688 6.74362C58.2063 7.56367 58.625 8.54948 58.625 9.70104V51.576C58.625 52.6927 58.2063 53.6698 57.3688 54.5073C56.5313 55.3448 55.5542 55.7635 54.4375 55.7635H41.9448L34.9656 62.7427C34.733 62.9753 34.4973 63.1382 34.2584 63.2313C34.0196 63.3243 33.7637 63.3708 33.4907 63.3708ZM12.5625 48.924C15.3542 46.3649 18.5156 44.2828 22.0469 42.6776C25.5782 41.0724 29.3935 40.2698 33.4927 40.2698C37.592 40.2698 41.4097 41.0724 44.9458 42.6776C48.4819 44.2828 51.6458 46.3649 54.4375 48.924V9.70104H12.5625V48.924ZM33.6396 34.7563C36.3382 34.7563 38.6181 33.8257 40.4792 31.9646C42.3403 30.1035 43.2708 27.8236 43.2708 25.125C43.2708 22.4264 42.3403 20.1465 40.4792 18.2854C38.6181 16.4243 36.3382 15.4938 33.6396 15.4938C30.941 15.4938 28.6611 16.4243 26.8 18.2854C24.9389 20.1465 24.0083 22.4264 24.0083 25.125C24.0083 27.8236 24.9389 30.1035 26.8 31.9646C28.6611 33.8257 30.941 34.7563 33.6396 34.7563ZM33.6396 30.5688C32.1274 30.5688 30.8421 30.0395 29.7836 28.981C28.7251 27.9225 28.1958 26.6372 28.1958 25.125C28.1958 23.6128 28.7251 22.3275 29.7836 21.269C30.8421 20.2105 32.1274 19.6813 33.6396 19.6813C35.1517 19.6813 36.4371 20.2105 37.4956 21.269C38.5541 22.3275 39.0833 23.6128 39.0833 25.125C39.0833 26.6372 38.5541 27.9225 37.4956 28.981C36.4371 30.0395 35.1517 30.5688 33.6396 30.5688ZM33.5 57.9969L39.9208 51.576H50.599V50.9479C48.0865 48.8076 45.3959 47.1908 42.5274 46.0974C39.6589 45.004 36.6497 44.4573 33.5 44.4573C30.3826 44.4573 27.3816 45.004 24.4969 46.0974C21.6122 47.1908 18.9135 48.8076 16.401 50.9479V51.576H27.0792L33.5 57.9969Z"
        fill="black"
      />
    </svg>
  );
};

const FilesIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.1458 43.75L38.9062 40.9375L34.0625 36.0937L31.25 38.8542C30.5556 39.5486 30.217 40.3646 30.2344 41.3021C30.2517 42.2396 30.5903 43.0555 31.25 43.75C31.9444 44.4097 32.7604 44.7483 33.6979 44.7656C34.6354 44.783 35.4514 44.4444 36.1458 43.75ZM41.0417 38.8021L43.8542 36.0417C44.5486 35.3472 44.8872 34.5312 44.8698 33.5937C44.8524 32.6562 44.4965 31.8403 43.8021 31.1458C43.1076 30.4514 42.3042 30.1042 41.3917 30.1042C40.4792 30.1042 39.6681 30.4514 38.9583 31.1458L36.1979 33.9583L41.0417 38.8021ZM38.3333 45.9375C37.0486 47.2222 35.5035 47.8646 33.6979 47.8646C31.8924 47.8646 30.3472 47.2222 29.0625 45.9375C27.7778 44.6528 27.1354 43.1076 27.1354 41.3021C27.1354 39.4965 27.7778 37.9514 29.0625 36.6667L36.7708 28.9583C38.0556 27.6736 39.6007 27.0312 41.4062 27.0312C43.2118 27.0312 44.7569 27.6736 46.0417 28.9583C47.3264 30.243 47.9687 31.7882 47.9687 33.5937C47.9687 35.3993 47.3264 36.9444 46.0417 38.2292L38.3333 45.9375ZM9.375 43.75C8.51562 43.75 7.77995 43.444 7.16797 42.832C6.55599 42.22 6.25 41.4844 6.25 40.625V9.37499C6.25 8.51562 6.55599 7.77994 7.16797 7.16796C7.77995 6.55598 8.51562 6.24999 9.375 6.24999H20.0521C20.2257 5.03472 20.7812 4.03645 21.7187 3.2552C22.6562 2.47395 23.75 2.08333 25 2.08333C26.25 2.08333 27.3437 2.47395 28.2812 3.2552C29.2187 4.03645 29.7743 5.03472 29.9479 6.24999H40.625C41.4844 6.24999 42.2201 6.55598 42.832 7.16796C43.444 7.77994 43.75 8.51562 43.75 9.37499V24.1667C43.2292 24.0278 42.7083 23.941 42.1875 23.9062C41.6667 23.8715 41.1458 23.8889 40.625 23.9583V9.37499H9.375V40.625H24.0104C23.9757 41.1458 23.9844 41.6667 24.0365 42.1875C24.0885 42.7083 24.184 43.2292 24.3229 43.75H9.375ZM25 8.48958C25.4861 8.48958 25.9115 8.30729 26.276 7.9427C26.6406 7.57812 26.8229 7.15277 26.8229 6.66666C26.8229 6.18055 26.6406 5.7552 26.276 5.39062C25.9115 5.02604 25.4861 4.84374 25 4.84374C24.5139 4.84374 24.0885 5.02604 23.724 5.39062C23.3594 5.7552 23.1771 6.18055 23.1771 6.66666C23.1771 7.15277 23.3594 7.57812 23.724 7.9427C24.0885 8.30729 24.5139 8.48958 25 8.48958ZM14.5833 17.7083V14.5833H35.4167V17.7083H14.5833ZM14.5833 26.5625V23.4375H35.4167V25.9896C35.3125 26.059 35.1997 26.1458 35.0781 26.25C34.9566 26.3542 34.8437 26.4583 34.7396 26.5625H14.5833ZM14.5833 35.4167V32.2917H29.0104L26.8229 34.4792C26.6493 34.6528 26.5017 34.809 26.3802 34.9479C26.2587 35.0868 26.1285 35.243 25.9896 35.4167H14.5833Z"
        fill="black"
      />
    </svg>
  );
};

const YoutubeIcon = () => {
  return (
    <svg
      width="42"
      height="30"
      viewBox="0 0 42 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.5166 27.4042C25.6541 27.4361 24.8316 27.4601 24.0489 27.476C23.2663 27.492 22.5715 27.5 21.9646 27.5H20C17.7319 27.5 15.6076 27.468 13.6271 27.4042C11.934 27.3403 10.2649 27.2524 8.61977 27.1406C6.97463 27.0288 5.7847 26.8771 5.04998 26.6854C4.21942 26.4618 3.50067 26.0465 2.89373 25.4396C2.28679 24.8326 1.87151 24.1139 1.6479 23.2833C1.45623 22.5486 1.30449 21.6542 1.19269 20.6C1.08088 19.5458 0.993035 18.5396 0.929146 17.5812C0.865257 16.4312 0.833313 15.2653 0.833313 14.0833C0.833313 12.9014 0.865257 11.7354 0.929146 10.5854C0.993035 9.62707 1.08088 8.62082 1.19269 7.56666C1.30449 6.51249 1.45623 5.61805 1.6479 4.88332C1.87151 4.05277 2.28679 3.33402 2.89373 2.72707C3.50067 2.12013 4.21942 1.70485 5.04998 1.48124C5.7847 1.28957 6.97463 1.13784 8.61977 1.02603C10.2649 0.914226 11.934 0.826379 13.6271 0.76249C15.6076 0.698601 17.7319 0.666656 20 0.666656C22.268 0.666656 24.3923 0.698601 26.3729 0.76249C28.066 0.826379 29.735 0.914226 31.3802 1.02603C33.0253 1.13784 34.2153 1.28957 34.95 1.48124C35.7805 1.70485 36.4993 2.12013 37.1062 2.72707C37.7132 3.33402 38.1285 4.05277 38.3521 4.88332C38.5437 5.61805 38.6955 6.51249 38.8073 7.56666C38.9191 8.62082 39.0069 9.62707 39.0708 10.5854C39.1347 11.7354 39.1666 12.9014 39.1666 14.0833V14.8979C38.5597 14.6424 37.9368 14.4427 37.2979 14.2989C36.659 14.1552 36.0041 14.0833 35.3333 14.0833C32.6819 14.0833 30.4219 15.0177 28.5531 16.8864C26.6844 18.7552 25.75 21.0153 25.75 23.6667C25.75 24.3375 25.8139 24.9844 25.9416 25.6073C26.0694 26.2302 26.2611 26.8292 26.5166 27.4042ZM16.1666 19.8333L26.1333 14.0833L16.1666 8.33332V19.8333ZM33.4166 29.4167V25.5833H29.5833V21.75H33.4166V17.9167H37.25V21.75H41.0833V25.5833H37.25V29.4167H33.4166Z"
        fill="black"
      />
    </svg>
  );
};

const HeartIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 42.7083C24.6285 42.7083 24.2504 42.6412 23.8656 42.5068C23.4809 42.3725 23.1425 42.1575 22.8506 41.862L20.1042 39.3229C15.7986 35.3299 12.066 31.5191 8.90627 27.8906C5.74655 24.2622 4.16669 20.4687 4.16669 16.5104C4.16669 13.38 5.21703 10.7658 7.31773 8.66786C9.41842 6.56984 12.0139 5.52083 15.1042 5.52083C16.875 5.52083 18.6285 5.94618 20.3646 6.79687C22.1007 7.64757 23.6459 9.04514 25 10.9896C26.5278 9.04514 28.1077 7.64757 29.7396 6.79687C31.3715 5.94618 33.0903 5.52083 34.8959 5.52083C37.9861 5.52083 40.5816 6.56984 42.6823 8.66786C44.783 10.7658 45.8334 13.38 45.8334 16.5104C45.8334 20.4687 44.2535 24.2622 41.0938 27.8906C37.934 31.5191 34.2014 35.3299 29.8959 39.3229L27.1354 41.875C26.849 42.166 26.5169 42.3776 26.1393 42.5099C25.7617 42.6422 25.382 42.7083 25 42.7083ZM23.6459 14.4271C22.7084 12.7257 21.4757 11.3368 19.9479 10.2604C18.4202 9.18403 16.8056 8.64583 15.1042 8.64583C12.8125 8.64583 10.9375 9.38368 9.47919 10.8594C8.02085 12.3351 7.29169 14.2262 7.29169 16.5328C7.29169 18.5318 7.9667 20.6364 9.31674 22.8466C10.6668 25.0568 12.2814 27.2009 14.1605 29.2789C16.0396 31.3568 17.9861 33.2899 20 35.0781C22.0139 36.8663 23.6806 38.3681 25 39.5833C26.3195 38.4028 27.9861 36.9097 30 35.1042C32.0139 33.2986 33.9584 31.3455 35.8334 29.2448C37.7084 27.1441 39.3229 24.988 40.6771 22.7765C42.0313 20.5649 42.7084 18.4762 42.7084 16.5104C42.7084 14.2187 41.9705 12.3351 40.4948 10.8594C39.0191 9.38368 37.1528 8.64583 34.8959 8.64583C33.1597 8.64583 31.5365 9.17535 30.0261 10.2344C28.5156 11.2934 27.257 12.691 26.25 14.4271C26.0764 14.7049 25.8854 14.9045 25.6771 15.026C25.4688 15.1476 25.2257 15.2083 24.9479 15.2083C24.6702 15.2083 24.4184 15.1476 24.1927 15.026C23.967 14.9045 23.7847 14.7049 23.6459 14.4271Z"
        fill="black"
      />
    </svg>
  );
};

const TimeIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.0625 29.25V18.5625C32.0625 18.0208 31.8854 17.5729 31.5312 17.2188C31.1771 16.8646 30.7292 16.6875 30.1875 16.6875C29.6458 16.6875 29.1979 16.8646 28.8437 17.2188C28.4896 17.5729 28.3125 18.0208 28.3125 18.5625V30C28.3125 30.25 28.3542 30.4792 28.4375 30.6875C28.5208 30.8958 28.6458 31.1042 28.8125 31.3125L37.8125 40.625C38.1875 41.0417 38.6562 41.2396 39.2187 41.2188C39.7812 41.1979 40.25 41 40.625 40.625C41 40.25 41.1875 39.7917 41.1875 39.25C41.1875 38.7083 41 38.25 40.625 37.875L32.0625 29.25ZM30 55C26.5833 55 23.3542 54.3438 20.3125 53.0312C17.2708 51.7188 14.6146 49.9271 12.3437 47.6562C10.0729 45.3854 8.28125 42.7292 6.96875 39.6875C5.65625 36.6458 5 33.4167 5 30C5 26.5833 5.65625 23.3542 6.96875 20.3125C8.28125 17.2708 10.0729 14.6146 12.3437 12.3438C14.6146 10.0729 17.2708 8.28125 20.3125 6.96875C23.3542 5.65625 26.5833 5 30 5C33.4167 5 36.6458 5.65625 39.6875 6.96875C42.7292 8.28125 45.3854 10.0729 47.6562 12.3438C49.9271 14.6146 51.7187 17.2708 53.0312 20.3125C54.3437 23.3542 55 26.5833 55 30C55 33.4167 54.3437 36.6458 53.0312 39.6875C51.7187 42.7292 49.9271 45.3854 47.6562 47.6562C45.3854 49.9271 42.7292 51.7188 39.6875 53.0312C36.6458 54.3438 33.4167 55 30 55ZM30 51.25C35.8333 51.25 40.8333 49.1667 45 45C49.1667 40.8333 51.25 35.8333 51.25 30C51.25 24.1667 49.1667 19.1667 45 15C40.8333 10.8333 35.8333 8.75 30 8.75C24.1667 8.75 19.1667 10.8333 15 15C10.8333 19.1667 8.75 24.1667 8.75 30C8.75 35.8333 10.8333 40.8333 15 45C19.1667 49.1667 24.1667 51.25 30 51.25Z"
        fill="black"
      />
    </svg>
  );
};

const AppointmentStatus = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 61 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_89)">
        <path
          d="M48.2917 5.08333H45.75V2.54167C45.75 1.13867 44.6113 0 43.2083 0C41.8053 0 40.6667 1.13867 40.6667 2.54167V5.08333H20.3333V2.54167C20.3333 1.13867 19.1947 0 17.7917 0C16.3887 0 15.25 1.13867 15.25 2.54167V5.08333H12.7083C5.70096 5.08333 0 10.7843 0 17.7917V48.2917C0 55.299 5.70096 61 12.7083 61H48.2917C55.299 61 61 55.299 61 48.2917V17.7917C61 10.7843 55.299 5.08333 48.2917 5.08333ZM48.2917 55.9167H12.7083C8.50442 55.9167 5.08333 52.4956 5.08333 48.2917V25.4167H20.3333C21.7363 25.4167 22.875 24.278 22.875 22.875C22.875 21.472 21.7363 20.3333 20.3333 20.3333H5.08333V17.7917C5.08333 13.5878 8.50442 10.1667 12.7083 10.1667H48.2917C52.4956 10.1667 55.9167 13.5878 55.9167 17.7917V20.3333H40.6667C39.2637 20.3333 38.125 21.472 38.125 22.875C38.125 24.278 39.2637 25.4167 40.6667 25.4167H55.9167V48.2917C55.9167 52.4956 52.4956 55.9167 48.2917 55.9167ZM33.0417 22.875V40.6667C33.0417 42.0697 31.903 43.2083 30.5 43.2083C29.097 43.2083 27.9583 42.0697 27.9583 40.6667V22.875C27.9583 21.472 29.097 20.3333 30.5 20.3333C31.903 20.3333 33.0417 21.472 33.0417 22.875ZM33.0417 48.2917C33.0417 49.6947 31.903 50.8333 30.5 50.8333C29.097 50.8333 27.9583 49.6947 27.9583 48.2917C27.9583 46.8887 29.097 45.75 30.5 45.75C31.903 45.75 33.0417 46.8887 33.0417 48.2917Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_89">
          <rect width="61" height="61" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const InvoiceIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.875 55C12.0521 55 10.5026 54.362 9.22656 53.0859C7.95052 51.8099 7.3125 50.2604 7.3125 48.4375V42.5C7.3125 41.9688 7.49219 41.5234 7.85156 41.1641C8.21094 40.8047 8.65625 40.625 9.1875 40.625H15.25V6.625C15.25 6.20833 15.4167 6 15.75 6C16.0833 6 16.4167 6.16667 16.75 6.5L19 8.75L22.0625 5.6875C22.2557 5.47917 22.481 5.375 22.7386 5.375C22.9962 5.375 23.2292 5.47917 23.4375 5.6875L26.4375 8.75L29.5 5.6875C29.6932 5.47917 29.9185 5.375 30.1761 5.375C30.4337 5.375 30.6667 5.47917 30.875 5.6875L33.9375 8.75L37 5.6875C37.1932 5.47917 37.4185 5.375 37.6761 5.375C37.9337 5.375 38.1667 5.47917 38.375 5.6875L41.4375 8.75L44.5 5.6875C44.6932 5.47917 44.9185 5.375 45.1761 5.375C45.4337 5.375 45.6667 5.47917 45.875 5.6875L48.9375 8.75L51.1875 6.5C51.5208 6.16667 51.8542 6 52.1875 6C52.5208 6 52.6875 6.214 52.6875 6.642V48.4375C52.6875 50.2604 52.0495 51.8099 50.7734 53.0859C49.4974 54.362 47.9479 55 46.125 55H13.875ZM46.125 51.25C46.9583 51.25 47.6354 50.9896 48.1562 50.4688C48.6771 49.9479 48.9375 49.2708 48.9375 48.4375V11.25H19V40.625H41.4375C41.9688 40.625 42.4141 40.8047 42.7734 41.1641C43.1328 41.5234 43.3125 41.9688 43.3125 42.5V48.4278C43.3125 49.2676 43.5729 49.9479 44.0938 50.4688C44.6146 50.9896 45.2917 51.25 46.125 51.25ZM24.125 21.125C23.625 21.125 23.1979 20.9375 22.8438 20.5625C22.4896 20.1875 22.3125 19.7396 22.3125 19.2188C22.3125 18.6979 22.4922 18.2604 22.8516 17.9062C23.2109 17.5521 23.6562 17.375 24.1875 17.375H35.4375C35.9688 17.375 36.4141 17.5557 36.7734 17.9172C37.1328 18.2787 37.3125 18.7266 37.3125 19.2609C37.3125 19.7953 37.1328 20.2396 36.7734 20.5938C36.4141 20.9479 35.9688 21.125 35.4375 21.125H24.125ZM24.125 29.5C23.625 29.5 23.1979 29.3125 22.8438 28.9375C22.4896 28.5625 22.3125 28.1146 22.3125 27.5938C22.3125 27.0729 22.4922 26.6354 22.8516 26.2812C23.2109 25.9271 23.6562 25.75 24.1875 25.75H35.4375C35.9688 25.75 36.4141 25.9307 36.7734 26.2922C37.1328 26.6537 37.3125 27.1016 37.3125 27.6359C37.3125 28.1703 37.1328 28.6146 36.7734 28.9688C36.4141 29.3229 35.9688 29.5 35.4375 29.5H24.125ZM43.125 21.125C42.625 21.125 42.1875 20.9375 41.8125 20.5625C41.4375 20.1875 41.25 19.75 41.25 19.25C41.25 18.75 41.4375 18.3125 41.8125 17.9375C42.1875 17.5625 42.625 17.375 43.125 17.375C43.625 17.375 44.0625 17.5625 44.4375 17.9375C44.8125 18.3125 45 18.75 45 19.25C45 19.75 44.8125 20.1875 44.4375 20.5625C44.0625 20.9375 43.625 21.125 43.125 21.125ZM43.125 29.1875C42.625 29.1875 42.1875 29 41.8125 28.625C41.4375 28.25 41.25 27.8125 41.25 27.3125C41.25 26.8125 41.4375 26.375 41.8125 26C42.1875 25.625 42.625 25.4375 43.125 25.4375C43.625 25.4375 44.0625 25.625 44.4375 26C44.8125 26.375 45 26.8125 45 27.3125C45 27.8125 44.8125 28.25 44.4375 28.625C44.0625 29 43.625 29.1875 43.125 29.1875ZM13.8125 51.25H39.5625V44.375H11.0625V48.4375C11.0625 49.2708 11.326 49.9479 11.8531 50.4688C12.3802 50.9896 13.0333 51.25 13.8125 51.25Z"
        fill="black"
      />
    </svg>
  );
};

const VideoConversationIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_307)">
        <path
          d="M39.1667 3.91666H7.83335C5.67919 3.91666 3.93627 5.67916 3.93627 7.83332L3.91669 43.0833L11.75 35.25H39.1667C41.3209 35.25 43.0834 33.4875 43.0834 31.3333V7.83332C43.0834 5.67916 41.3209 3.91666 39.1667 3.91666ZM39.1667 31.3333H10.1246L7.83335 33.6246V7.83332H39.1667V31.3333Z"
          fill="black"
        />
        <path
          d="M15.6667 27.4167H27.4167C28.4938 27.4167 29.375 26.5354 29.375 25.4583V21.5613L33.2917 25.4583V13.7083L29.375 17.6054V13.7083C29.375 12.6313 28.4938 11.75 27.4167 11.75H15.6667C14.5896 11.75 13.7084 12.6313 13.7084 13.7083V25.4583C13.7084 26.5354 14.5896 27.4167 15.6667 27.4167Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_307">
          <rect width="47" height="47" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const SupportIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_269)">
        <path
          d="M56.875 33.0958C56.875 18.2271 45.3375 8.125 32.5 8.125C19.7979 8.125 8.125 18.0104 8.125 33.2583C6.5 34.1792 5.41666 35.9125 5.41666 37.9167V43.3333C5.41666 46.3125 7.85416 48.75 10.8333 48.75H13.5417V32.2292C13.5417 21.7479 22.0187 13.2708 32.5 13.2708C42.9813 13.2708 51.4583 21.7479 51.4583 32.2292V51.4583H29.7917V56.875H51.4583C54.4375 56.875 56.875 54.4375 56.875 51.4583V48.1542C58.4729 47.3146 59.5833 45.6625 59.5833 43.7125V37.4833C59.5833 35.5875 58.4729 33.9354 56.875 33.0958Z"
          fill="black"
        />
        <path
          d="M24.375 37.9167C25.8708 37.9167 27.0833 36.7041 27.0833 35.2083C27.0833 33.7126 25.8708 32.5 24.375 32.5C22.8792 32.5 21.6667 33.7126 21.6667 35.2083C21.6667 36.7041 22.8792 37.9167 24.375 37.9167Z"
          fill="black"
        />
        <path
          d="M40.625 37.9167C42.1208 37.9167 43.3333 36.7041 43.3333 35.2083C43.3333 33.7126 42.1208 32.5 40.625 32.5C39.1292 32.5 37.9167 33.7126 37.9167 35.2083C37.9167 36.7041 39.1292 37.9167 40.625 37.9167Z"
          fill="black"
        />
        <path
          d="M48.75 29.8729C47.45 22.1542 40.7333 16.25 32.6354 16.25C24.4292 16.25 15.6 23.0479 16.3042 33.7188C22.9937 30.9833 28.0312 25.025 29.4667 17.7667C33.0146 24.8896 40.3 29.7917 48.75 29.8729Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_269">
          <rect width="65" height="65" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const PatientConsent = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_243)">
        <path
          d="M24.5 2.04166L6.125 10.2083V22.4583C6.125 33.7896 13.965 44.3858 24.5 46.9583C35.035 44.3858 42.875 33.7896 42.875 22.4583V10.2083L24.5 2.04166ZM38.7917 22.4583C38.7917 26.2354 37.7504 29.9104 35.9742 33.0954L33.0138 30.135C35.6475 26.1742 35.1983 20.7842 31.7071 17.2929C27.7258 13.3117 21.2538 13.3117 17.2725 17.2929C13.2913 21.2742 13.2913 27.7462 17.2725 31.7275C20.7638 35.2188 26.1538 35.6475 30.1146 33.0342L33.6262 36.5458C31.1967 39.445 28.0525 41.6704 24.5 42.7525C16.2925 40.2004 10.2083 31.6867 10.2083 22.4583V12.8625L24.5 6.51291L38.7917 12.8625V22.4583ZM24.5 30.625C21.1108 30.625 18.375 27.8892 18.375 24.5C18.375 21.1108 21.1108 18.375 24.5 18.375C27.8892 18.375 30.625 21.1108 30.625 24.5C30.625 27.8892 27.8892 30.625 24.5 30.625Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_243">
          <rect width="49" height="49" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const CancelAppointmentIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_178)">
        <path
          d="M38.7917 6.125H36.75V2.04166H32.6667V6.125H16.3333V2.04166H12.25V6.125H10.2083C7.9625 6.125 6.125 7.9625 6.125 10.2083V38.7917C6.125 41.0375 7.9625 42.875 10.2083 42.875H38.7917C41.0375 42.875 42.875 41.0375 42.875 38.7917V10.2083C42.875 7.9625 41.0375 6.125 38.7917 6.125ZM38.7917 38.7917H10.2083V18.375H38.7917V38.7917ZM10.2083 14.2917V10.2083H38.7917V14.2917H10.2083ZM16.8029 33.5037L18.9671 35.6679L23.9487 30.6862L28.9304 35.6679L31.0946 33.5037L26.1129 28.5221L31.0946 23.5404L28.9304 21.3762L23.9487 26.3579L18.9671 21.3762L16.8029 23.5404L21.7846 28.5221L16.8029 33.5037Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_178">
          <rect width="49" height="49" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const PrescriptionIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_178)">
        <path d="m694-120 53-54-93-93-54 53q-20 20-19.5 47t19.5 47q20 19 47 19.5t47-19.5Zm94-95 54-53q20-20 19.5-47T841-362q-20-20-46.28-20T748-362l-53 54 93 93ZM736-78q-37 37-89 37t-89-37q-37-37-37-89t37-89l148-148q37-37 89-37t89 37q37 37 37 89t-37 89L736-78ZM180-180v-600 600Zm0 60q-24.75 0-42.375-17.625T120-180v-600q0-24.75 17.625-42.375T180-840h205q5-35 32-57.5t63-22.5q36 0 63 22.5t32 57.5h205q24.75 0 42.375 17.625T840-780v284q-15-4-30-5t-30 1v-280H180v600h281q-1 15 .5 30t5.5 30H180Zm300-677q14 0 24.5-10.5T515-832q0-14-10.5-24.5T480-867q-14 0-24.5 10.5T445-832q0 14 10.5 24.5T480-797ZM280-620v-60h400v60H280Zm0 170v-60h400v49q-3 2-6.5 5t-6.5 6H280Zm0 170v-60h277l-42 42q-5 5-8.5 9t-7.5 9H280Z"   fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_1_173">
          <rect width="49" height="49" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DashboardIcons = {
  BookIcon,
  ProfileIcon,
  FilesIcon,
  YoutubeIcon,
  HeartIcon,
  TimeIcon,
  AppointmentStatus,
  InvoiceIcon,
  VideoConversationIcon,
  SupportIcon,
  PatientConsent,
  CancelAppointmentIcon,
  PrescriptionIcon
};
